module.exports = __webpack_public_path__ + "img/7_r.23ce6f96.jpg";